import api from '@/libs/axios'
import { PaginatedList } from '../models/common/paginatedList'
import { StaffingEntreprise, StaffingStatut, StaffingUtilisateur } from '../models/staffing/staffing'

const resource = 'staffing'

export default class StaffingRessource {
  public async getStaffingUtilisateurs(
    pagenumber?: number,
    pagesize?: number,
    search?: string,
    statut?: StaffingStatut,
    structureId?: string
  ): Promise<PaginatedList<StaffingUtilisateur>> {
    const params = new URLSearchParams()
    if (pagenumber) params.append('PageNumber', pagenumber.toString())
    if (pagesize) params.append('PageSize', pagesize.toString())
    if (search && search.length) params.append('Search', search)
    if (statut) params.append('Statut', statut)
    if (structureId) params.append('StructureId', structureId)

    const response = await api.get(`${resource}/utilisateurs`, { params })
    return response.data
  }

  public async getStaffingEntreprises(
    pagenumber?: number,
    pagesize?: number,
    search?: string,
    statut?: StaffingStatut
  ): Promise<PaginatedList<StaffingEntreprise>> {
    const params = new URLSearchParams()
    if (pagenumber) params.append('PageNumber', pagenumber.toString())
    if (pagesize) params.append('PageSize', pagesize.toString())
    if (search && search.length) params.append('Search', search)
    if (statut) params.append('Statut', statut)

    const response = await api.get(`${resource}/entreprises`, { params })
    return response.data
  }
}
